// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.text-edit-box {
    position: relative;
    display: inline-block;
}

.text-edit-input {
    background-color: white;
    border: none;
    padding: 0.5rem 2.5rem 0.5rem 0.5rem;
    font-size: 1rem;
    width: 100%;
    transition: border 0.2s ease;
    border: 1px solid transparent;
}

.text-edit-box:hover .text-edit-input {
    border: 1px solid #0078d4;
}

.text-edit-box.editing .text-edit-input {
    border: 1px solid lightgrey;
}

.text-edit-button {
    position: absolute;
    width: fit-content;
    height: fit-content;
    top: -13px;
    right: -13px;
    border-radius: 50%;
    background-color: #0078d4;
    color: white;
}

.text-edit-box > .base-button {
    padding: 3px;
}

.text-edit-button-group {
    position: absolute;
    top: -13px;
    right: -13px;
    display: flex;
    gap: 0.25rem;
}

    .text-edit-button-group > .base-button {
        position: relative;
        padding: 3px;
        top: 0px;
        right: 0px;
    }

        .text-edit-button-group > .base-button > span.glyph-button-content {
            margin: 2px;
        }

.save-text-input {
    background-color: forestgreen;
}

.cancel-text-input {
    background-color: orangered;
}
`, "",{"version":3,"sources":["webpack://./src/Controls/Input/css/TextInput.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,oCAAoC;IACpC,eAAe;IACf,WAAW;IACX,4BAA4B;IAC5B,6BAA6B;AACjC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,UAAU;IACV,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,aAAa;IACb,YAAY;AAChB;;IAEI;QACI,kBAAkB;QAClB,YAAY;QACZ,QAAQ;QACR,UAAU;IACd;;QAEI;YACI,WAAW;QACf;;AAER;IACI,6BAA6B;AACjC;;AAEA;IACI,2BAA2B;AAC/B","sourcesContent":[".text-edit-box {\r\n    position: relative;\r\n    display: inline-block;\r\n}\r\n\r\n.text-edit-input {\r\n    background-color: white;\r\n    border: none;\r\n    padding: 0.5rem 2.5rem 0.5rem 0.5rem;\r\n    font-size: 1rem;\r\n    width: 100%;\r\n    transition: border 0.2s ease;\r\n    border: 1px solid transparent;\r\n}\r\n\r\n.text-edit-box:hover .text-edit-input {\r\n    border: 1px solid #0078d4;\r\n}\r\n\r\n.text-edit-box.editing .text-edit-input {\r\n    border: 1px solid lightgrey;\r\n}\r\n\r\n.text-edit-button {\r\n    position: absolute;\r\n    width: fit-content;\r\n    height: fit-content;\r\n    top: -13px;\r\n    right: -13px;\r\n    border-radius: 50%;\r\n    background-color: #0078d4;\r\n    color: white;\r\n}\r\n\r\n.text-edit-box > .base-button {\r\n    padding: 3px;\r\n}\r\n\r\n.text-edit-button-group {\r\n    position: absolute;\r\n    top: -13px;\r\n    right: -13px;\r\n    display: flex;\r\n    gap: 0.25rem;\r\n}\r\n\r\n    .text-edit-button-group > .base-button {\r\n        position: relative;\r\n        padding: 3px;\r\n        top: 0px;\r\n        right: 0px;\r\n    }\r\n\r\n        .text-edit-button-group > .base-button > span.glyph-button-content {\r\n            margin: 2px;\r\n        }\r\n\r\n.save-text-input {\r\n    background-color: forestgreen;\r\n}\r\n\r\n.cancel-text-input {\r\n    background-color: orangered;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
